<ng-container *ngIf="availableOffersCounter > 0">
    <!-- Product item offers -->
        <!-- Single offer -->
    <ng-container *ngIf="isSingleOffer()">
        <ng-container *ngIf="coupons[0]?.isClippable && coupons[0]?.ecomDescription">
            <ng-container *ngIf="coupons[0]?.status === 'U' || coupons[0]?.deleted === true">
                <div class="product-coupon__info d-flex sunshine50 px-2 py-1">
                    <button class="border-0 sunshine50 p-0" (click)="$event.stopPropagation();setProductDetails('offer-detail');"
                    (keyup.enter)="setProductDetails('offer-detail')" attr.aria-label="{{'Details for ' + singleCouponText + ' coupon for ' + getProductFullName() + ' unclipped, view deals'}}">
                        <span
                            class="body-text-xs product-coupon__info__text text-wrap text-left color-neutral-90">{{singleCouponText}}</span>
                    </button>
                    <button data-qa="clpscssrs-btn" class="product-coupon__icon-circle rounded-circle p-0 d-flex justify-content-center align-items-center" (click)="clipCoupon()" id="couponAddBtn{{coupons[0].offerId}}"
                        attr.aria-label="{{'Clip coupon for ' + singleCouponText + ' for ' + getProductFullName()}}">
                        <span class="svg-scissor background-color-primary-default m-0"></span>
                    </button>
                </div>
            </ng-container>
            <ng-container *ngIf="coupons[0]?.status === 'C' && coupons[0]?.deleted === false">
                    <div class="product-coupon__info d-flex sunshine50 px-2 py-1">
                        <button class="border-0 sunshine50 p-0" (click)="$event.stopPropagation();setProductDetails('offer-detail');"
                        (keyup.enter)="setProductDetails('offer-detail')"  attr.aria-label="{{singleCouponText + ' coupon clipped for ' + getProductFullName() + ' clipped, view deals'}}">
                            <span
                                class="body-text-xs product-coupon__info__text text-wrap text-left color-neutral-90">{{singleCouponText}}</span>
                        </button>
                        <span data-qa="clpchk-btn" class="svg-coupon-redesign-tick-mark background-color-primary-default m-1"
                            aria-hidden="true"></span>
                        <span aria-live="polite" class="sr-only">{{adaText}}</span>
                    </div>
            </ng-container>
        </ng-container>
        <!-- To display NDC coupons -->
        <ng-container *ngIf="coupons && coupons.length > 0 && !coupons[0].isClippable && coupons[0].ecomDescription">
            <div class="product-coupon__info d-flex sunshine50 px-2 py-1">
                <button *ngIf="configObj?.programType !== '1P_SNS' && configObj?.appName !== '1P_OA'" class="border-0 sunshine50 p-0"  (click)="$event.stopPropagation();setProductDetails('offer-detail');"
                (keyup.enter)="setProductDetails('offer-detail')"  attr.aria-label="{{'Details for ' + singleCouponText + ' coupon for ' + getProductFullName()}}">
                    <span
                        class="body-text-xs product-coupon__info__text text-wrap text-left color-neutral-90">{{singleCouponText}}</span>
                </button>
                <div *ngIf="configObj?.programType === '1P_SNS' || configObj?.appName === '1P_OA'" class="border-0 sunshine50 p-0">
                    <span class="sr-only">{{'Details for ' + singleCouponText + ' coupon for ' + getProductFullName()}}</span>
                    <span aria-hidden="true" class="body-text-xs product-coupon__info__text text-wrap text-left color-neutral-90">{{singleCouponText}}</span>
                </div>
                <span class="svg-coupon-redesign-tick-mark background-color-primary-default m-1"
                    aria-hidden="true"></span>
                <span aria-live="polite" class="sr-only">{{adaText}}</span>
            </div>
        </ng-container>
    </ng-container>

    <!-- if promotype is equal to M or B -->
    <ng-container *ngIf="isSingleBogoOffer()">
        <div class="product-coupon__info d-flex sunshine50 px-2 py-1">
            <button *ngIf="configObj?.programType !== '1P_SNS' && configObj?.appName !== '1P_OA'" class="border-0 sunshine50 p-0"
                (click)="$event.stopPropagation();setProductDetails('bogo-detail');" (keyup.enter)="setProductDetails('bogo-detail')"
                attr.aria-label="{{'Details for ' + bogoText + ' offer for ' + getProductFullName()}}">
                <span
                    class="body-text-xs product-coupon__info__text text-wrap text-left color-neutral-90">{{bogoText}}</span>
            </button>
            <div *ngIf="configObj?.programType === '1P_SNS' || configObj?.appName === '1P_OA'" class="border-0 sunshine50 p-0">
                <span class="sr-only">{{'Details for ' + bogoText + ' offer for ' + getProductFullName()}}</span>
                <span aria-hidden="true" class="body-text-xs product-coupon__info__text text-wrap text-left color-neutral-90">{{bogoText}}</span>
            </div>
            <span class="svg-coupon-redesign-tick-mark background-color-primary-default m-1" aria-hidden="true"></span>
            <span aria-live="polite" class="sr-only">{{adaText}}</span>
        </div>
    </ng-container>

    <!-- Multiple offers -->
    <ng-container *ngIf="availableOffersCounter > 1">
        <div aria-live="polite" class="product-coupon__info d-flex sunshine50 px-2 py-1" *ngIf="offersClippedCounter === 0" >
            <button (click)="$event.stopPropagation();setProductDetails('coupon-list');" attr.aria-label="{{ couponsText + ' for ' + getProductFullName()}}"
            class="border-0 sunshine50 p-0" data-qa="prd-itm-multi-coupon">
                <span class="body-text-xs product-coupon__info__text text-wrap text-left color-neutral-90">{{couponsText}}</span>
            </button>
        </div>
        <ng-container *ngIf="offersClippedCounter > 0">
            <div aria-live="polite" class="product-coupon__info d-flex sunshine50 px-2 py-1"  >
                <button (click)="$event.stopPropagation();setProductDetails('coupon-list');" class="border-0 sunshine50 p-0" data-qa="prd-itm-multi-coupon" 
                attr.aria-label="{{ couponsText + ' for ' + getProductFullName() + ' ' + offersClippedCounter + ' of ' + availableOffersCounter +' clipped, view deals' }}">
                    <span class="body-text-xs product-coupon__info__text text-wrap text-left color-neutral-90">{{multipleClippedCouponsText}}</span>
                </button>
                <ng-container *ngIf="offersClippedCounter === availableOffersCounter" >
                    <span class="svg-coupon-redesign-tick-mark background-color-primary-default m-1" aria-hidden="true"></span>
                    <span aria-live="polite" class="sr-only">clipped</span>
                </ng-container>
            </div>
        </ng-container>
    </ng-container>
</ng-container>



